import { FC, MouseEventHandler } from 'react';

import styled from 'styled-components';

import Button from '@components/Button';

export const Wrapper = styled.div`
  background: rgba(58, 58, 58, 0.2);
  padding: 20px;
  border-radius: 2px;
  button {
    height: 58px;
    font-weight: bold;
    font-size: 18px;
  }
`;

const BookerSearchButton: FC<{
  onClick: MouseEventHandler<HTMLElement> | undefined;
}> = ({ onClick }) => {
  return (
    <Wrapper>
      <Button block onClick={onClick}>
        Ara
      </Button>
    </Wrapper>
  );
};

export default BookerSearchButton;
